'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { connect } from 'react-redux';
import { EntityTypes } from 'AdsUI/lib/Constants';
import makeLoadable from 'AdsUI/lib/makeLoadable';
import { getCampaignForCampaignDetails, getCampaignRequestStatus } from 'AdsUI/selectors/CampaignReportingSelectors';
import { getNetworkFromParams } from 'AdsUI/selectors/PropsSelectors';
import { getAdAccountFromParams } from 'AdsUI/selectors/AccountsSelectors';
import UILoadingOverlay from 'UIComponents/loading/UILoadingOverlay';
import FailedEntityManagementPanel from 'AdsUI/components/campaign-reporting/FailedEntityManagementPanel';
const EntityManagementPanelContainerLoader = makeLoadable(() => import('./EntityManagementPanelContainer'));

const CampaignManagementPanelContainer = ({
  network,
  campaignDetails,
  adAccount,
  campaignRequestStatus,
  history,
  location: {
    pathname
  }
}) => campaignRequestStatus.fetchedSuccessfully() ? /*#__PURE__*/_jsx(EntityManagementPanelContainerLoader, {
  entityType: EntityTypes.CAMPAIGN,
  entity: campaignDetails.entity,
  campaignEntity: campaignDetails.entity,
  network: network,
  adAccount: adAccount,
  onClose: () => {
    history.push(`${pathname.replace('/manage-campaign', '')}${window.location.search}`);
  }
}) : campaignRequestStatus.fetchFailed ? /*#__PURE__*/_jsx(FailedEntityManagementPanel, {
  entityType: EntityTypes.CAMPAIGN,
  network: network,
  onClose: () => {
    history.push(`${pathname.replace('/manage-campaign', '')}${window.location.search}`);
  }
}) : /*#__PURE__*/_jsx(UILoadingOverlay, {});

const mapStateToProps = (state, props) => ({
  adAccount: getAdAccountFromParams(state, props),
  network: getNetworkFromParams(state, props),
  campaignDetails: getCampaignForCampaignDetails(state, props),
  campaignRequestStatus: getCampaignRequestStatus(state, props)
});

export default connect(mapStateToProps)(CampaignManagementPanelContainer);